<template>
  <div class="main">
    <div class="query-item">
      <div class="search-l">
        <div class="ml5">
          企业
          <a-select class="select-narrow ml24" placeholder="请选择" v-model:value="query.deptId" allow-clear>
            <a-select-option v-for="option in companyList" :key="option.deptId" :value="option.deptId">
              {{ option.name }}
            </a-select-option>
          </a-select>
        </div>
        <div class="ml30">
          运营公司
          <a-select class="select-narrow ml24" placeholder="请选择" v-model:value="query.operatorId" allow-clear>
            <a-select-option v-for="option in operatorList" :key="option.value" :value="option.id">
              {{ option.name }}
            </a-select-option>
          </a-select>
        </div>
        <div class="ml30">
          牌照/车架号
          <a-input class="inp ml24" placeholder="请输入" v-model:value="query.sk"></a-input>
        </div>

        <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
        <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
      </div>
      <div class="search-r">
        <!-- 右侧按钮区域可以根据需要添加 -->
      </div>
    </div>
    <a-table :columns="columns" :row-key="(record) => record.id"
             size="middle" class="mt23" :scroll="{ x: 1500, y: 'auto' }"
             v-autoHeight="{ extraHeight: 88, trHeight: 47 }"
             :data-source="dataSource"
             :pagination="pagination">
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'action'">
          <span>
<!--            <a @click="detail(record)">详情</a>-->
<!--            <a v-if="store.hasPermi('car:update:apply')" class="ml10" v-hasRole="['carEnterprise']">信息变更申请</a>-->
          </span>
        </template>
      </template>
    </a-table>

  </div>
</template>
<script setup>
import { ref, onMounted, reactive } from "vue";
import { useRouter, useRoute } from "vue-router";
import { getVehiclePageList } from "@/api/vehicle/index";
import { getCompanyList } from "@/api/enterprise/index";
import { getOperatorList } from "@/api/settings/operator";
import useUserStore from '@/store/modules/user'

const router = useRouter();
const store = useUserStore();
const route = useRoute();

import useAppStore from "@/store/modules/app";
const appStore = useAppStore();

const columns = [
  {
    title: "企业名称",
    dataIndex: "deptName",
    key: "deptName",
  },
  {
    title: "车辆编码",
    key: "licenceNo",
    dataIndex: "licenceNo",
    width: 120,
  },
  {
    title: "车辆型号",
    key: "model",
    dataIndex: "model",
    width: 110,
  },
  {
    title: "车辆识别代码",
    key: "vin",
    dataIndex: "vin",
    width: 180,
  },
  {
    title: "车辆类型",
    key: "vehicleTypeName",
    dataIndex: "vehicleTypeName",
    width: 160,
  },
  {
    title: "运营公司",
    key: "operatorName",
    dataIndex: "operatorName",
    width: 180,
  },
  {
    title: "车身颜色",
    key: "color",
    dataIndex: "color",
    width: 80,

  },
  {
    title: "动力形式",
    key: "powerType",
    dataIndex: "powerType",
    width: 120,
  },
  {
    title: "生产企业",
    dataIndex: "manufacturer",
    key: "manufacturer",
  },
  {
    title: "生产日期",
    key: "productionDate",
    dataIndex: "productionDate",
  },
  {
    title: "操作",
    key: "action",
    fixed: 'right',
    width: 180,
  },
];

let dataSource = ref([]);


let companyList = ref([]);
let operatorList = ref([]);

let query = reactive({
  deptId: "",
  operatorId: "",
  vin: "",
  sk: ""
});

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 20, //每页中显示10条数据
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"], //每页中显示的数据
  showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize), // 改变每页数量时更新显示
  onChange: pageChange, //点击页码事件
  showSizeChange: pageSizeChange,
});

function pageChange(page, pageSize) {
  pagination.current = page;

  // 获取表格数据
  getData();
}

function pageSizeChange(current, size) {
  console.log(size);
  pagination.pageSize = size;

  // 获取表格数据
  getData();
}

const search = () => {
  pagination.current = 1;
  getData();
};

const reset = () => {
  query.deptName = "";
  query.vin = "";
  query.testNum = "";
  query.applicationStatus = "";
  pagination.current = 1;
  getData();
};

const getData = () => {
  console.log(store.deptId, 12454)
  const data = {
    pageIndex: pagination.current,
    pageSize: pagination.pageSize,
    conditionMap: { ...query, dept_id: query.deptId || store.deptId },
  };
  getVehiclePageList(data).then((res) => {
    dataSource.value = res.data.records || [];
    pagination.total = res.data.total;
  });
};

onMounted(async () => {
  // 获取企业列表
  getCompanyList().then(res => {
    if (res.code === 200 && res.data) {
      companyList.value = res.data;
    }
  });

  // 获取运营公司列表
  getOperatorList().then(res => {
    if (res.code === 200 && res.data) {
      operatorList.value = res.data;
    }
  });

  // 获取路由参数
  const testNum = route.query.testNum;
  if (testNum){
    query.testNum = testNum;
  }
  getData();
});

const detail = (record) => {
  console.log(record);
  router.push({
    path: "/carManage/carDetail",
    query: { id: record.id }
  });
};

</script>

<style lang="less" scoped>
.inp {
  width: 13.5vw;
}

.select-narrow {
  width: 8vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
  }

  .search-r {
    display: flex;
  }
}

/deep/.ant-input::placeholder {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #68767E;
}

/deep/.ant-select-selector {
  background-color: #F2F4F7 !important;
  color: #68767E !important;
}

.main {
  padding: 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(10, 33, 46, 1);
  background-color: rgba(239, 240, 245, 1);
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody>tr {
  color: rgba(104, 118, 126, 1);
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
.ant-table-wrapper .ant-table-thead>tr>td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  width: 0px;
}

a {
  color: #1E8EF2;
}
</style>
@/api/car/car.js